import axios from 'axios'
import config from '@/configs/config'

export default () => {
    return axios.create({
        baseURL: config.factoryTourApiUrl
    });
}
